import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        portalId: String,
        formId: String,
    }

    connect() {
        this.loadHubSpotScript()
    }

    loadHubSpotScript() {
        if (window.hbspt) {
            this.initializeForm()
            return
        }

        const script = document.createElement('script')
        script.src = '//js.hsforms.net/forms/embed/v2.js'
        script.async = true
        script.onload = () => this.initializeForm()
        document.head.appendChild(script)
    }

    initializeForm() {
        hbspt.forms.create({
            target: '#contactForm',
            portalId: this.portalIdValue,
            formId: this.formIdValue,
            onFormReady: this.bootstrapifyForm.bind(this),
        })
    }

    bootstrapifyForm() {
        const form = this.element.querySelector('form')
        if (!form) return

        form.querySelectorAll('input, textarea').forEach((input) => {
            input.classList.add('form-control')
        })

        form.querySelectorAll('label').forEach((label) => {
            label.classList.add('form-label')
        })
    }
}
